import script from "./InformationAccountCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationAccountCustomer.vue?vue&type=script&setup=true&lang=js"

import "./InformationAccountCustomer.vue?vue&type=style&index=0&id=0bf69ed5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf69ed5"]])

export default __exports__